import { message } from 'antd';
import { put, takeLatest } from 'redux-saga/effects';
import { logger } from 'services';
import { floatUid } from 'utils/uid';
import { createSpaceInProjectTemplate } from '../../actions';
import { createProjectTemplateSpace } from '../../slices';
function* createSpaceInTemplateSaga(action) {
    try {
        const { payload } = action;
        const spaceId = floatUid();
        const space = {
            ...payload.space,
            spaceId
        };
        yield put(createProjectTemplateSpace(space));
    } catch (error) {
        logger.error('createProjectTemplateSpace failed', {
            error
        });
        message.error('There was an error creating a space in the template');
    }
}
export function* watchCreateSpaceInProjectTemplateSaga() {
    yield takeLatest(createSpaceInProjectTemplate.type, createSpaceInTemplateSaga);
}
